import { render, staticRenderFns } from "./WorkerPositions.vue?vue&type=template&id=4a8ac8c1"
import script from "./WorkerPositions.vue?vue&type=script&lang=ts"
export * from "./WorkerPositions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports